import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { BookOpen } from 'lucide-react';
import { PageShareTitle } from '../../lib/shareTitle';
import {
  docsHubRouteRef,
  docHomeRouteRef,
  docApprovalsRouteRef,
  docWorkflowsRouteRef,
  docCatalogRouteRef,
  docIntegrationsRouteRef,
  docWorkflowDetailRouteRef,
  docApprovalKindDetailRouteRef,
  docAdminDashboardRouteRef,
  docOthersRouteRef,
  docRefreshRouteRef,
  docMergeLordRouteRef,
  docQuicklinksRouteRef,
  docFeedbackRouteRef,
  docDeploymentsRouteRef,
  docKafkaQueryRouteRef,
} from './routeRefs';

export {
  docsHubRouteRef,
  docHomeRouteRef,
  docApprovalsRouteRef,
  docWorkflowsRouteRef,
  docCatalogRouteRef,
  docIntegrationsRouteRef,
  docWorkflowDetailRouteRef,
  docApprovalKindDetailRouteRef,
  docAdminDashboardRouteRef,
  docOthersRouteRef,
  docRefreshRouteRef,
  docMergeLordRouteRef,
  docQuicklinksRouteRef,
  docFeedbackRouteRef,
  docDeploymentsRouteRef,
  docKafkaQueryRouteRef,
} from './routeRefs';

export const docsHubPage = PageBlueprint.make({
  name: 'hub',
  params: {
    path: '/help',
    title: 'Help',
    icon: <BookOpen size={20} strokeWidth={2} />,
    routeRef: docsHubRouteRef,
    noHeader: true,
    loader: () =>
      import('./DocsHubPage').then(m => (
        <PageShareTitle title="Help">
          <m.DocsHubPage />
        </PageShareTitle>
      )),
  },
});

export const docHomePage = PageBlueprint.make({
  name: 'home',
  params: {
    path: '/help/home',
    routeRef: docHomeRouteRef,
    noHeader: true,
    loader: () =>
      import('./HomeDocPage').then(m => (
        <PageShareTitle title="Home help">
          <m.HomeDocPage />
        </PageShareTitle>
      )),
  },
});

export const docApprovalsPage = PageBlueprint.make({
  name: 'approvals',
  params: {
    path: '/help/approvals',
    routeRef: docApprovalsRouteRef,
    noHeader: true,
    loader: () =>
      import('./ApprovalsDocPage').then(m => (
        <PageShareTitle title="Approvals help">
          <m.ApprovalsDocPage />
        </PageShareTitle>
      )),
  },
});

export const docWorkflowsPage = PageBlueprint.make({
  name: 'workflows',
  params: {
    path: '/help/workflows',
    routeRef: docWorkflowsRouteRef,
    noHeader: true,
    loader: () =>
      import('./WorkflowsDocPage').then(m => (
        <PageShareTitle title="Workflows help">
          <m.WorkflowsDocPage />
        </PageShareTitle>
      )),
  },
});

export const docCatalogPage = PageBlueprint.make({
  name: 'catalog',
  params: {
    path: '/help/catalog',
    routeRef: docCatalogRouteRef,
    noHeader: true,
    loader: () =>
      import('./CatalogDocPage').then(m => (
        <PageShareTitle title="Catalog help">
          <m.CatalogDocPage />
        </PageShareTitle>
      )),
  },
});

export const docIntegrationsPage = PageBlueprint.make({
  name: 'integrations',
  params: {
    path: '/help/integrations',
    routeRef: docIntegrationsRouteRef,
    noHeader: true,
    loader: () =>
      import('./IntegrationsDocPage').then(m => (
        <PageShareTitle title="Integrations help">
          <m.IntegrationsDocPage />
        </PageShareTitle>
      )),
  },
});

export const docWorkflowDetailPage = PageBlueprint.make({
  name: 'workflow-detail',
  params: {
    path: '/help/workflows/:slug',
    routeRef: docWorkflowDetailRouteRef,
    noHeader: true,
    loader: () =>
      import('./WorkflowDetailPage').then(m => <m.WorkflowDetailPage />),
  },
});

export const docApprovalKindDetailPage = PageBlueprint.make({
  name: 'approval-kind-detail',
  params: {
    path: '/help/approvals/:kindId',
    routeRef: docApprovalKindDetailRouteRef,
    noHeader: true,
    loader: () =>
      import('./ApprovalKindDetailPage').then(m => (
        <m.ApprovalKindDetailPage />
      )),
  },
});

export const docAdminDashboardPage = PageBlueprint.make({
  name: 'admin-dashboard',
  params: {
    path: '/help/admin-dashboard',
    routeRef: docAdminDashboardRouteRef,
    noHeader: true,
    loader: () =>
      import('./AdminDashboardDocPage').then(m => (
        <PageShareTitle title="Admin dashboard help">
          <m.AdminDashboardDocPage />
        </PageShareTitle>
      )),
  },
});

export const docOthersPage = PageBlueprint.make({
  name: 'others',
  params: {
    path: '/help/others',
    routeRef: docOthersRouteRef,
    noHeader: true,
    loader: () =>
      import('./OthersDocPage').then(m => (
        <PageShareTitle title="Other pages help">
          <m.OthersDocPage />
        </PageShareTitle>
      )),
  },
});

export const docRefreshPage = PageBlueprint.make({
  name: 'refresh',
  params: {
    path: '/help/refresh',
    routeRef: docRefreshRouteRef,
    noHeader: true,
    loader: () =>
      import('./RefreshDocPage').then(m => (
        <PageShareTitle title="Refresh help">
          <m.RefreshDocPage />
        </PageShareTitle>
      )),
  },
});

export const docKafkaQueryPage = PageBlueprint.make({
  name: 'kafka-query',
  params: {
    path: '/help/kafka-query',
    routeRef: docKafkaQueryRouteRef,
    noHeader: true,
    loader: () =>
      import('./KafkaQueryDocPage').then(m => (
        <PageShareTitle title="Kafka Query help">
          <m.KafkaQueryDocPage />
        </PageShareTitle>
      )),
  },
});

export const docMergeLordPage = PageBlueprint.make({
  name: 'merge-lord',
  params: {
    path: '/help/merge-lord',
    routeRef: docMergeLordRouteRef,
    noHeader: true,
    loader: () =>
      import('./MergeLordDocPage').then(m => (
        <PageShareTitle title="Merge Lord help">
          <m.MergeLordDocPage />
        </PageShareTitle>
      )),
  },
});

export const docQuicklinksPage = PageBlueprint.make({
  name: 'quicklinks',
  params: {
    path: '/help/quicklinks',
    routeRef: docQuicklinksRouteRef,
    noHeader: true,
    loader: () =>
      import('./QuicklinksDocPage').then(m => (
        <PageShareTitle title="Quicklinks help">
          <m.QuicklinksDocPage />
        </PageShareTitle>
      )),
  },
});

export const docFeedbackPage = PageBlueprint.make({
  name: 'feedback',
  params: {
    path: '/help/feedback',
    routeRef: docFeedbackRouteRef,
    noHeader: true,
    loader: () =>
      import('./FeedbackDocPage').then(m => (
        <PageShareTitle title="Feedback help">
          <m.FeedbackDocPage />
        </PageShareTitle>
      )),
  },
});

export const docDeploymentsPage = PageBlueprint.make({
  name: 'deployments',
  params: {
    path: '/help/deployments',
    routeRef: docDeploymentsRouteRef,
    noHeader: true,
    loader: () =>
      import('./DeploymentsDocPage').then(m => (
        <PageShareTitle title="Deployments help">
          <m.DeploymentsDocPage />
        </PageShareTitle>
      )),
  },
});

export const helpPlugin = createFrontendPlugin({
  pluginId: 'help',
  extensions: [
    docsHubPage,
    docHomePage,
    docApprovalsPage,
    docWorkflowsPage,
    docCatalogPage,
    docIntegrationsPage,
    docWorkflowDetailPage,
    docApprovalKindDetailPage,
    docAdminDashboardPage,
    docOthersPage,
    docRefreshPage,
    docMergeLordPage,
    docQuicklinksPage,
    docFeedbackPage,
    docDeploymentsPage,
    docKafkaQueryPage,
  ],
  routes: {
    hub: docsHubRouteRef,
    home: docHomeRouteRef,
    approvals: docApprovalsRouteRef,
    workflows: docWorkflowsRouteRef,
    catalog: docCatalogRouteRef,
    integrations: docIntegrationsRouteRef,
    workflowDetail: docWorkflowDetailRouteRef,
    approvalKindDetail: docApprovalKindDetailRouteRef,
    adminDashboard: docAdminDashboardRouteRef,
    others: docOthersRouteRef,
    refresh: docRefreshRouteRef,
    mergeLord: docMergeLordRouteRef,
    quicklinks: docQuicklinksRouteRef,
    feedback: docFeedbackRouteRef,
    deployments: docDeploymentsRouteRef,
    kafkaQuery: docKafkaQueryRouteRef,
  },
});
